import { SvgBase } from "../svg.base";

export const ArrowRight = () => (
  <SvgBase
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
     <g fill="none" fillRule="evenodd">
        <g fill="#FFF" fillRule="nonzero">
            <g>
                <g>
                    <path d="M20 11L7.83 11 13.42 5.41 12 4 4 12 12 20 13.41 18.59 7.83 13 20 13z" transform="translate(-1108 -106) translate(962 102) translate(146 4) matrix(-1 0 0 1 24 0)"/>
                </g>
            </g>
        </g>
    </g>
  </SvgBase>
);